import React, { useState, useEffect } from 'react'
import { COLORS } from '../../Constants/AppColors.js'
import { useTranslation } from 'react-i18next'
import '../../Translation/i18n'
import i18n from 'i18next'
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Aos from 'aos'
import 'aos/dist/aos.css'
import APIs from '../../network/APIs.js'
import './style.css'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const itemData = [
  {
    img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
    title: 'Breakfast',
    author: '@bkristastucchio',
  },
  {
    img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
    title: 'Burger',
    author: '@rollelflex_graphy726',
  },
  {
    img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
    title: 'Camera',
    author: '@helloimnik',
  },
  {
    img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
    title: 'Coffee',
    author: '@nolanissac',
  },
  {
    img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
    title: 'Hats',
    author: '@hjrc33',
  },
  {
    img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
    title: 'Honey',
    author: '@arwinneil',
  },
  {
    img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',
    title: 'Basketball',
    author: '@tjdragotta',
  },
  {
    img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',
    title: 'Fern',
    author: '@katie_wasserman',
  },
  {
    img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',
    title: 'Mushrooms',
    author: '@silverdalex',
  },
  {
    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
    title: 'Tomato basil',
    author: '@shelleypauls',
  },
  {
    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
    title: 'Tomato basil',
    author: '@shelleypauls',
  },
  {
    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
    title: 'Tomato basil',
    author: '@shelleypauls',
  },
  {
    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
    title: 'Tomato basil',
    author: '@shelleypauls',
  },
  {
    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
    title: 'Tomato basil',
    author: '@shelleypauls',
  },
  {
    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
    title: 'Tomato basil',
    author: '@shelleypauls',
  },
  {
    img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',
    title: 'Sea star',
    author: '@peterlaster',
  },
  {
    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
    title: 'Bike',
    author: '@southside_customs',
  },
  {
    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
    title: 'Bike',
    author: '@southside_customs',
  },
  {
    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
    title: 'Bike',
    author: '@southside_customs',
  },
  {
    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
    title: 'Bike',
    author: '@southside_customs',
  },
  {
    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
    title: 'Bike',
    author: '@southside_customs',
  },
]

function PartnersInSuccessPage() {
  const { t } = useTranslation()

  const [innerWidthState, setInnerWidthState] = useState(window.innerWidth)
  const [innerHeightState, setInnerHeightState] = useState(window.innerHeight)
  const [directionState, setDirectionState] = useState('ltr')

  const [partnersResponseState, setPartnersResponseState] = useState([])
  const [
    partnersCategoryResponseState,
    setPartnersCategoryResponseState,
  ] = useState([])

  React.useEffect(() => {
    Aos.init()

    const getPartnersInSuccess = () => {
      console.log('getPartnersInSuccess() Started')
  
      APIs.instance.getPartnersInSuccess().then(([statusCode, data]) => {
        if (statusCode === 200) {
          setPartnersCategoryResponseState(data.results)
        }
      })
    }

   getPartnersInSuccess()

    if (i18n.language.includes('en')) {
      setDirectionState('ltr')
    } else {
      setDirectionState('rtl')
    }

    function handleResize() {
      console.log('resized to: ', window.innerWidth, 'x', window.innerHeight)
      setInnerWidthState(window.innerWidth)
      setInnerHeightState(window.innerHeight)
    }

    window.addEventListener('resize', handleResize)

    console.log('i18n.locale: ' + i18n.language)
  }, [])

  const listCategoryItems = partnersCategoryResponseState.map((item) => (
    <Container>
      <label
        style={{
          color: COLORS.PageTitleFirstColor,
          marginTop: 20,
          marginBottom: -20,
          fontSize: 30,
          textAlign: i18n.language.includes('en') ? 'left' : 'right',
          fontFamily: i18n.language.includes('en')
            ? 'CI-Font-Title'
            : 'CI-Font-Title-ar',
        }}
      >
        {i18n.language.includes('en') ? item.name_en : item.name_ar}
      </label>
      <Row md={5}>
        {item.partners.map((partnerItem, index) => (
          <Col>
            <div
              data-aos="fade-zoom-out"
              data-aos-offset="100"
              class="col-11 col-md-6 col-lg-2 mx-0 mb-5"
            >
              <div
                class="card p-0 overflow-hidden shadow"
                style={{
                  marginTop: 20,
                  borderRadius: 20,
                  height: 150,
                  width: 150,
                  justifyContent: 'center',
                }}
              >
                <img
                  src={partnerItem.image}
                  class="thumbnail img-responsive img-fluid mx-auto"
                  style={{
                    padding: 5,
                    borderColor: '#00000001',
                  }}
                  alt=""
                />
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  ))

  return (
    <div
      dir={directionState}
      style={{
        backgroundColor: '#F7F8F9',
        backgroundSize: 'cover',
        // display: "flex",
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <label
          style={{
            color: COLORS.PageTitleFirstColor,
            marginTop: 20,
            marginBottom: -20,
            fontSize: 35,
            textAlign: i18n.language.includes('en') ? 'left' : 'right',
            fontFamily: i18n.language.includes('en')
              ? 'CI-Font-Title'
              : 'CI-Font-Title-ar',
          }}
        >
          {t('Partners_In_Success_pt1')}{' '}
          <label
            style={{
              color: COLORS.PageTitleSecondColor,
              fontSize: 35,
              textAlign: i18n.language.includes('en') ? 'left' : 'right',
              fontFamily: i18n.language.includes('en')
                ? 'CI-Font-Title'
                : 'CI-Font-Title-ar',
            }}
          >
            {t('Partners_In_Success_pt2')}
          </label>
        </label>
        <section className="py-4 py-lg-5 container">
          {partnersCategoryResponseState.length === 0 ? null : (
            <div className="row">{listCategoryItems}</div>
          )}
        </section>
      </div>
    </div>
  )
}

export default PartnersInSuccessPage
